<section class="panels-wrapper" #panelsWrapper id="editor-panels-wrapper" role="dialog" aria-modal="true" [attr.aria-label]="'Item Editor Modal'">
  <div id="editor-header" class="header primary-bg-color" *ngIf="(viewPort$ | async)?.isMobile">
    <div class="header-content">
      <span class="font-secondary text-uppercase text-muted fw-400">{{'component.item_editor.editor.customize_selection' | translate}}</span>
      <button class='btn dismiss-button no-padding' id='close-editor-btn' aria-label='Close editor' (click)="closeEditor()">
        <span aria-hidden='true'><fa-icon [icon]="faRemove" [size]="'1x'"></fa-icon></span>
      </button>
    </div>
  </div>

  <div *ngIf="orderedItem"
       class="padded-left-sm-down padded-right description-and-controls-panel"
       [ngClass]="{'builder' : (orderableItem?.useBuilder && !canvasNotSupported), 'in-modal no-padding': inItemEditorModal && !(viewPort$ | async)?.isMobile}">

    <a *ngIf="!(breakPointService.isTabletDown$ | async) && !inItemEditorModal" class="font-secondary primary-text-color" [routerLink]="menuRouteLink" [fragment]="previousFragment">
      <fa-icon class="margin-right-10" [icon]="faCaretLeft"></fa-icon>
      {{'component.item_editor.editor.view' | translate}} {{previousCategory}}
    </a>

    <!-- Clasic Item Editor -->
    <ng-container *ngIf="!isHalfAndHalf">
      <div class='item-info'>
        <h2 class='fw-600 font-secondary item-name'>
          {{orderableItem?.label}}<sup *ngIf="orderedItem.labelSymbol">{{orderedItem.labelSymbol}}</sup>
        </h2>
        <div *ngIf="!(breakPointService.isTabletDown$ | async)" class='calories fw-600 calories-display'>
          {{calories}}
        </div>
        <p *ngIf="storeConfig?.itemWebDescriptionInEditor && orderableItem.description">{{orderableItem.description}}</p>
        <fts-print-ingredients *ngIf="!(storeConfig?.itemWebDescriptionInEditor && orderableItem.description)" [printableIngredients]="printableIngredients" (ingredientNameClick)="handleIngredientNameClick($event)"></fts-print-ingredients>
      </div>
      <ng-container 
      *ngIf="!!imageSrc && !(orderableItem?.useBuilder && !canvasNotSupported) && theme.showItemImage">
        <img 
        style="width: 100%;" 
        [ngStyle]="{
          'height':imageLoaded?'auto':'210px'
        }"
        [src]='imageSrc'  
        (load)="imgLoaded($event)"
        [alt]="'route.menu.menu_tab.card_menu_item.card_menu_item_image.image_alt' | translate: { itemLabel: orderableItem?.label }">
      </ng-container>
      <ng-container *ngIf="orderableItem?.useBuilder && !canvasNotSupported">
        <div class="builder-container" *ngIf="!(breakPointService.isXSMobile$ | async)">
          <fts-pizza-builder [orderable]="orderableItem" [ordered]="orderedItem" (onCanvasNotSupported)="switchToSimpleEditor()" role="img"
                            [attr.aria-label]="'component.item_editor.editor.pizza_builder' | translate"></fts-pizza-builder>
        </div>
      </ng-container>
    </ng-container>
    
    <!-- HALFS EDITOR -->
    <div *ngIf="isHalfAndHalf" class="halfs-editor-container">
      <span class="half-item-label text-uppercase">{{halfAndHalfLabel ? halfAndHalfLabel : 'component.item_editor.editor.half_and_half' | translate}}</span>
      <div class="half-selectors-container">
        <!-- LEFT HALF SELECTION EDITOR -->
        <div class="half-selector-container" [ngClass]="{'action-border-color': activeHalfSide === halfSelectionSideType.LEFT}">
          <div class="halfs-selector-title-container">
            <button (click)="changeHalf(halfSelectionSideType.LEFT, true)"  class="halfs-selector-title primary-text-color">{{(!!leftSelectedHalf ? 'component.item_editor.editor.left_half' :'component.item_editor.editor.step_one_left_half') | translate}}</button>
            <div *ngIf="!!leftSelectedHalf" class="check-round-icon">
              <fa-icon [icon]="faCheck"  class="d-flex" ></fa-icon>
            </div>
          </div>
          <div class="half-selector-info-container">
            <button 
              class="half-label primary-text-color" 
              (click)="changeHalf(halfSelectionSideType.LEFT, true)"  
              [ngClass]="{'underline-half-label': !!leftSelectedHalf}">
              {{leftSelectedHalf ? leftSelectedHalf.name : 
              ('component.item_editor.editor.select_specialty_category' | translate:{category: orderedItem?.category})}}
            </button>
            <span *ngIf="!!leftSelectedHalf" class="half-printable-ingredients">
              <span *ngFor="let ingredient of leftPrintableIngredients; let last = last" [ngClass]="{'text-danger':ingredient.isRemoved}">
                <span *ngIf="ingredient.isRemoved">{{"No"}}</span>
                <ng-container *ngIf="ingredient.isRightHalf && ingredient.secondHalfQualifiers?.length">
                  <span *ngFor="let qualifier of ingredient.secondHalfQualifiers; let first = first">
                    <span *ngIf="!first">{{' '}}</span>
                    <span>{{qualifier}}</span>
                  </span>
                </ng-container>
                <ng-container *ngIf="!ingredient.isRightHalf">
                  <span *ngFor="let qualifier of ingredient.qualifiers; let first = first">
                    <span *ngIf="!first">{{' '}}</span>
                    <span>{{qualifier}}</span>
                  </span>
                </ng-container>
                <span>{{' '}}{{ingredient.name}}</span>
                <span *ngIf="!last">{{", "}}</span>
              </span>
            </span>
          </div>
          <div class="actions-container" *ngIf="!!leftSelectedHalf">
            <button (click)="modifyHalf(halfSelectionSideType.LEFT);" 
                    class="btn btn-link p-0 text-decoration-none modify-button">{{'component.item_editor.editor.customize' | translate}}
            </button>
          </div>
        </div>
        <!-- RIGHT HALF SELECTION EDITOR -->
        <!-- not selected right half-->
        <button class="half-selector-container" 
                *ngIf="!rightSelectedHalf"
                (click)="changeHalf(halfSelectionSideType.RIGHT, true)" 
                [disabled]="!leftSelectedHalf"
                [ngClass]="{'action-border-color' : activeHalfSide === halfSelectionSideType.RIGHT, 
                             'disabled':!leftSelectedHalf}">
          <div class="halfs-selector-title-container">
            <span class="halfs-selector-title primary-text-color">{{('component.item_editor.editor.step_two_right_half') | translate}}</span>
          </div>
          <span class="half-label primary-text-color">{{('component.item_editor.editor.select_specialty_category' | translate:{category: orderedItem?.category})}}</span>
        </button>
        <!-- selected right half -->
        <div *ngIf="!!rightSelectedHalf" class="half-selector-container" [ngClass]="{'action-border-color': activeHalfSide === halfSelectionSideType.RIGHT}">
          <div class="halfs-selector-title-container">
            <button class="halfs-selector-title primary-text-color" (click)="changeHalf(halfSelectionSideType.RIGHT, true)">{{(!!rightSelectedHalf ? 'component.item_editor.editor.right_half' :'component.item_editor.editor.step_one_right_half') | translate}}</button>
            <div *ngIf="!!rightSelectedHalf" class="check-round-icon">
              <fa-icon [icon]="faCheck"  class="d-flex" ></fa-icon>
            </div>
          </div>
          <div class="half-selector-info-container">
            <button class="half-label underline-half-label primary-text-color" (click)="changeHalf(halfSelectionSideType.RIGHT, true)" >{{rightSelectedHalf ? rightSelectedHalf.name : ('component.item_editor.editor.select_specialty_category' | translate:{category: orderedItem?.category})}}</button>
            <span *ngIf="!!rightSelectedHalf" class="half-printable-ingredients">
              <span *ngFor="let ingredient of rightPrintableIngredients; let last = last" [ngClass]="{'text-danger':ingredient.isRemoved}">
                <span *ngIf="ingredient.isRemoved">{{"No"}}</span>
                <ng-container *ngIf="ingredient.isLeftHalf && ingredient.secondHalfQualifiers?.length">
                  <span *ngFor="let qualifier of ingredient.secondHalfQualifiers; let first = first">
                    <span *ngIf="!first">{{' '}}</span>
                    <span>{{qualifier}}</span>
                  </span>
                </ng-container>
                <ng-container *ngIf="!ingredient.isLeftHalf">
                  <span *ngFor="let qualifier of ingredient.qualifiers; let first = first">
                    <span *ngIf="!first">{{' '}}</span>
                    <span>{{qualifier}}</span>
                  </span>
                </ng-container>
                <span>{{' '}}{{ingredient.name}}</span>
                <span *ngIf="!last">{{", "}}</span>
              </span>
            </span>
          </div>
          <div class="actions-container" *ngIf="!!rightSelectedHalf">
            <button (click)="modifyHalf(halfSelectionSideType.RIGHT);" 
                    class="btn btn-link p-0 text-decoration-none modify-button">{{'component.item_editor.editor.customize' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>   
    <!-- END HALFS EDITOR -->

    <div #editItemControls class="edit-item-controls" [ngStyle]="{'padding-bottom': !isHalfAndHalf && (breakPointService.isTabletDown$ | async) ? '50px' : '1rem'}" [ngClass]="{'halfs-controls':isHalfAndHalf && (viewPort$ | async).isMobile }">
      <fts-item-editor-controls
        [orderableItem]="orderableItem"
        [item]="orderedItem"
        [price]='price'
        [ingredientChoicesAsSteps]="ingredientChoicesAsSteps"
        [updatingOrderSubscription]="loadingSubscription"
        [storeConfig]="storeConfig"
        [inItemEditorModal]="inItemEditorModal"
        (quantityChange)='onQuantityChanged($event)'
        (orderUpdate)="addOrUpdateItem()"
        [isHalfAndHalf]="isHalfAndHalf"
        (sizeChanged)="changeSize($event)">
      </fts-item-editor-controls>
    </div>

    <div *ngIf="!isHalfAndHalf && (breakPointService.isTabletDown$ | async)">
      {{calories}}
    </div> 
    <span *ngIf="selectedSizePrice?.noticePeriod && storeConfig?.hasCateringNoticeTime" style="font-size: 18.66px; font-weight: 700;" class="selection-text-color">
      {{'component.item_editor.editor.prep_time' | translate}}{{formattedNoticePeriod}}
    </span>
  </div>
  <div id="secondColumnChoicesAndIngredients" class="choices-and-ingredients-panel" [ngClass]="{'in-modal overlay no-padding': (inItemEditorModal && !(viewPort$ | async)?.isMobile)}">

    <div *ngIf="builderImageLoading" [@fadeInOut] class="overlay-disable" [style.backgroundColor]="theme.primaryBackgroundColor | rgba : '0.6'">
      <div class="loading-container">
        <fts-loading-indicator></fts-loading-indicator>
      </div>
    </div>

    <div *ngIf='orderedItem && !isHalfAndHalf' class='edit-item-wrapper' [ngClass]="{'full-height': (viewPort$ | async)?.isMobile, 'no-padding': (inItemEditorModal && !(viewPort$ | async)?.isMobile)}">
      <div #editItemContent [ngClass]="{'no-steps-footer': (viewPort$ | async)?.isMobile && !ingredientChoicesAsSteps, 'edit-item-content': !inItemEditorModal || (viewPort$ | async)?.isMobile}">

        <fts-item-choices
          [ngClass]="{'item-choices-in-modal': (inItemEditorModal && !(viewPort$ | async)?.isMobile)}"
          [item]='orderedItem'
          [upsellItems]="upsellItems"
          [orderableItem]='orderableItem'
          [price]='price'
          [theme]='theme'
          (choiceClicked)="onNextChoiceClicked($event)"
          [hasGraphicalBuilder]="orderableItem?.useBuilder && !canvasNotSupported"
          [updatingOrderSubscription]="loadingSubscription"
          [inItemEditorModal]="inItemEditorModal"
          (ingredientChange)='onIngredientChanged($event)'
          (stageAction)="onStageAction($event)"
          (orderUpdate)="addOrUpdateItem()"
          (handledSizeChange)="sizeChanges()"
          (cancelBtnClick)="onCloseItemEditorModal()"
        ></fts-item-choices>

        <div class='padded-top-20 full-width visible-xs padded-right padded-left'
            *ngIf="!!orderableItem && (!ingredientChoicesAsSteps || !(viewPort$ | async)?.isDesktop) && orderableItem?.choices.length && !(viewPort$ | async)?.isMobile">
          <button
            ftsAsyncButton
            [subscription]='loadingSubscription'
            class='btn btn-block action-bg-color action-inverse-text-color shadowed action-btn font-secondary text-uppercase'
            (click)="addOrUpdateItem()">
            {{(orderedItem?.itemId ? 'component.item_editor.editor.update' : 'component.item_editor.editor.add_to_order') | translate}}
          </button>
        </div>
      </div>
      <div class="empty-space-filler overlay" *ngIf="(viewPort$ | async)?.isMobile"></div>
    </div>

    <!-- Halfs display container -->
    <!-- ------------------------------------------------- -->
    <div *ngIf="isHalfAndHalf && hiddenChoices && !(viewPort$ | async).isMobile"  class="halfs-display-container-header p-3" [ngClass]="{'in-editor-modal' : inItemEditorModal && !(viewPort$ | async).isMobile}">
      <span class="text-uppercase selection-title">{{(activeHalfSide === halfSelectionSideType.RIGHT ? 'component.item_editor.editor.select_right_half' : 'component.item_editor.editor.select_left_half') | translate}}</span>
      <button *ngIf="theme.showItemEditorModal" class='close' (click)='onCloseItemEditorModal()' ftsAuditableButton auditName="Close" [attr.aria-label]="'component.item_editor_modal.item_editor_modal_header.close' | translate">
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
    <div *ngIf="isHalfAndHalf && hiddenChoices" 
        class='halfs-display-container p-3' 
        [ngClass]="{'overlay': (viewPort$ | async)?.isMobile, 
                    'padded-right-20':  (inItemEditorModal && !(viewPort$ | async)?.isMobile),
                    'modal-choices-container':theme.showItemEditorModal && !(viewPort$ | async).isMobile}"
    >
      <fts-loading-indicator *ngIf="loadingSpecialtyHalfs"></fts-loading-indicator>
      <ng-container *ngIf="!loadingSpecialtyHalfs">
        <div ftsSticky [topMargin]="headerHeightOffset" class="primary-bg-color">
          <div  class="w-100 d-flex overlay justify-content-end padded-bottom-10 padded-top-5 toggle-details-container">
            <button class="btn btn-link btn-undecorated p-0 text-lowercase text-decoration-underline toggle-details-button" (click)="toggleSpecialtyHalfsDetails()">{{(showSpecialtyHalfDetails ? 'component.item_editor.editor.hide_details' : 'component.item_editor.editor.show_details') | translate}}</button>
          </div>
        </div>
        
        <div class="specialty-halfs-container" *ngIf="activeHalfSide === halfSelectionSideType.LEFT">
          <fts-specialty-half 
                *ngFor="let half of halfs" 
                [half]="half" 
                [theme]="theme"
                [selectedHalf]="leftSelectedHalf" 
                (halfClicked)="toggleSelectHalf($event)" 
                [showSpecialtyHalfDetails]="showSpecialtyHalfDetails"
          ></fts-specialty-half>
        </div>
        <div class="specialty-halfs-container" *ngIf="activeHalfSide === halfSelectionSideType.RIGHT">
          <fts-specialty-half 
              *ngFor="let half of halfs" 
              [half]="half" 
              [theme]="theme"
              [selectedHalf]="rightSelectedHalf" 
              (halfClicked)="toggleSelectHalf($event)" 
              [showSpecialtyHalfDetails]="showSpecialtyHalfDetails" 
          ></fts-specialty-half>
        </div>
      </ng-container>
    </div>
    <!-- ------------ END OF HALFS DISPLAY -------------------- -->


    <ng-container #outlet [ngTemplateOutlet]="content" *ngIf="isHalfAndHalf">
    </ng-container>
  </div>
</section>

<fts-back-to-top [scrollableElement]="(viewPort$ | async)?.isMobile ? scrollableElement:null"  [isHalfAndHalf]="isHalfAndHalf" [page]="'editor'"></fts-back-to-top>


<ng-template #content>
  <div *ngIf='orderedItem' class='edit-item-wrapper' [ngClass]="{'full-height': (viewPort$ | async)?.isMobile, 'no-padding': (inItemEditorModal && !(viewPort$ | async)?.isMobile), 'hidden-choices':isHalfAndHalf && hiddenChoices}">
    <div #editItemContent [ngClass]="{'no-steps-footer': (viewPort$ | async)?.isMobile && !ingredientChoicesAsSteps, 'edit-item-content': !inItemEditorModal || (viewPort$ | async)?.isMobile}">

      <fts-item-choices
        [ngClass]="{'item-choices-in-modal': (inItemEditorModal && !(viewPort$ | async)?.isMobile)}"
        [item]='orderedItem'
        [upsellItems]="upsellItems"
        [orderableItem]='orderableItem'
        [price]='price'
        [theme]='theme'
        (choiceClicked)="onNextChoiceClicked($event)"
        [hasGraphicalBuilder]="orderableItem?.useBuilder && !canvasNotSupported"
        [updatingOrderSubscription]="loadingSubscription"
        [inItemEditorModal]="inItemEditorModal"
        (ingredientChange)='onIngredientChanged($event)'
        (stageAction)="onStageAction($event)"
        (orderUpdate)="addOrUpdateItem()"
        (handledSizeChange)="sizeChanges()"
        (cancelBtnClick)="onCloseItemEditorModal()"
        (calculateIngredients)="calcPrintableIngredients()"
      ></fts-item-choices>

      <div class='padded-top-20 full-width visible-xs padded-right padded-left'
          *ngIf="!!orderableItem && (!ingredientChoicesAsSteps || !(viewPort$ | async)?.isDesktop) && orderableItem?.choices.length && !(viewPort$ | async)?.isMobile">
        <button
          ftsAsyncButton
          [subscription]='loadingSubscription'
          class='btn btn-block action-bg-color action-inverse-text-color shadowed action-btn font-secondary text-uppercase'
          (click)="addOrUpdateItem()">
          {{(orderedItem?.itemId ? 'component.item_editor.editor.update' : 'component.item_editor.editor.add_to_order') | translate}}
        </button>
      </div>
    </div>
    <div class="empty-space-filler overlay" *ngIf="(viewPort$ | async)?.isMobile"></div>
  </div>
</ng-template>